export const TableColumn = ({ dataKey, headingClassName = '', heading = '', cellClassName, renderCell }) => null
